import axios from "../axiosInstance";
import type { MembershipSku } from "@/modules/hub/features/MembershipSkuManagement/schemas/membershipSkuSchema";

/**
 * Fetch a single membership SKU by UUID
 */
export const fetchMembershipSkuByUuid = async (
  uuid: string,
): Promise<MembershipSku> => {
  const response = await axios.get<MembershipSku>(
    `/api/private/membership-skus/${uuid}`,
  );
  return response.data;
};
